import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';

const LOGIN_PATH = '/login';

// Backends before the 401 fix report auth failures as 403; tell them apart from real permission denials
// ("You do not have permission to perform this action.") by the error detail.
const AUTH_FAILURE_DETAIL = /credentials|token|session|inactive/i;

export const isAuthFailure = (status: unknown, detail: unknown) =>
  status === 401 ||
  (status === 403 && typeof detail === 'string' && AUTH_FAILURE_DETAIL.test(detail));

// Expired/invalid login: drop the stale credentials and send the user to the login page
// (otherwise every query fails and pages stay on their loaders forever).
export const rtkQueryErrorLogger: Middleware = () => next => (action: any) => {
  if (isRejectedWithValue(action)) {
    const payload = action.payload as { status?: unknown; data?: { detail?: unknown } } | undefined;
    if (
      isAuthFailure(payload?.status, payload?.data?.detail) &&
      window.location.pathname !== LOGIN_PATH
    ) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.assign(LOGIN_PATH);
    }
  }

  return next(action);
};

// utils.ts
export function getCookie(name: string) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const prepareHeaders = (headers: any, { getState, endpoint }: any) => {
  const accessToken = localStorage.getItem('token');
  if (accessToken && endpoint !== 'login') {
    headers.set('Authorization', `Token ${accessToken}`);
  }
  return headers;
};
